import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * General health forms
   */
  {
    // 1
    label:
      'Please upload a few clear pictures of the areas where acne is present',
    subLabel: '(Select one)',
    field: 'finalPhotos',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'photoYes',
          value: 'Yes'
        },
        {
          key: 'photoNo',
          value: 'No',
          answer: {
            label:
              'You’ve opted out of photos. Please describe your current skin condition below:',
            type: 'text',
            name: 'photoNoDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // 1-1
    field: 'finalUpload',
    label:
      'Please upload a few clear pictures of the areas where acne is present',
    subLabel: '(You can submit up to 5 photos)',
    type: 'image_list',
    answer: {
      option: {
        buttonLabel: 'Choose File',
        addLabel: '+Add another',
        resourceId: 'finalImages',
        limit: 5,
        required: true
      }
    }
  },
  {
    // 1-2
    label: {
      text: '<p class="body2">Photos uploaded</p><h3>Complete</h3>',
      align: 'center',
      icon: 'check-circle'
    },
    field: 'finalUploadDone',
    type: 'info',
    answer: {
      label:
        'Please provide any additional information you think may help the medical team in their assessment.',
      name: 'finalUploadDoneDesc',
      type: 'text',
      style: {
        labelAlign: 'center',
        round: true
      }
    }
  },
  {
    // 2
    label: 'Have you tried any of these before?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'finalTries',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'hydroquinone',
          value: 'Hydroquinone'
        },
        {
          key: 'retinol',
          value: 'Retinol'
        },
        {
          key: 'topicalSteroid',
          value: 'Topical steroid'
        },
        {
          key: 'triesNone',
          value: 'None of the above',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 2-1
    label: 'Tell us more!',
    subLabel: 'Please write your answer in the space provided',
    field: 'finalTriesMore', //
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Are you still using it?',
          type: 'single_select',
          level: 'child',
          halfWidth: true,
          options: [
            {
              key: 'tUsingYes',
              value: 'Yes'
            },
            {
              key: 'tUsingNo',
              value: 'No'
            }
          ]
        },
        {
          label: 'How did your skin respond, were there any side effects?',
          type: 'text',
          name: 'tSkinRespond'
        },
        {
          label: 'What strength of dosage did you use, and for how long?',
          type: 'text',
          name: 'tStrengthDosage'
        },
        {
          label:
            'Please provide any additional details you think may be useful.',
          type: 'text',
          name: 'tAdditional'
        }
      ]
    }
  },
  {
    // 3
    label: 'Have you been diagnosed with any skin conditions?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'finalDiagnosed',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'rosacea', value: 'Rosacea' },
        { key: 'dermatitis', value: 'Dermatitis' },
        { key: 'atopic', value: 'Atopic Dermatitis' },
        { key: 'acne', value: 'Acne' },
        { key: 'psoriasis', value: 'Psoriasis' },
        {
          key: 'otherDiagnosed',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherDiagnosedDesc',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'noDiagnosed',
          value: 'No',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    // 3-1
    label:
      'Are you currently using any prescription medication for acne? If so, please specify.',
    subLabel: '(Select only one)',
    field: 'finalPrescription',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'retinA', value: 'Retin-A' },
        { key: 'retinAMicro', value: 'Retin-A Micro' },
        { key: 'tazorac', value: 'Tazorac' },
        { key: 'differin', value: 'Differin' },
        { key: 'benzaclin', value: 'Benzaclin' },
        { key: 'clindoxyl', value: 'Clindoxyl' },
        { key: 'notSure', value: 'Not sure' },
        { key: 'prescriptionNone', value: 'None' }
      ]
    }
  },
  {
    // 3-2
    label: 'Tell us more!',
    subLabel: 'Please write your answer in the space provided',
    field: 'finalPrescriptionMore', //
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Are you still using it?',
          type: 'single_select',
          level: 'child',
          halfWidth: true,
          options: [
            {
              key: 'pUsingYes',
              value: 'Yes'
            },
            {
              key: 'pUsingNo',
              value: 'No'
            }
          ]
        },
        {
          label: 'How did your skin respond, were there any side effects?',
          type: 'text',
          name: 'pSkinRespond'
        },
        {
          label: 'What strength of dosage did you use, and for how long?',
          type: 'text',
          name: 'pStrengthDosage'
        },
        {
          label:
            'Please provide any additional details you think may be useful.',
          type: 'text',
          name: 'pAdditional'
        }
      ]
    }
  },
  {
    // 4
    label: 'Are you taking any oral antibiotics?',
    subLabel: '(Select only one)',
    field: 'finalOral',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'oralYes',
          value: 'Yes'
        },
        {
          key: 'oralNo',
          value: 'No'
        }
      ]
    }
  },
  {
    // 4-1
    label: 'Are you taking any oral antibiotics?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'finalOralDetail',
    type: 'select',
    answer: {
      type: 'multi_select',
      halfWidth: true,
      options: [
        { key: 'Doxy', value: 'Doxy' },
        { key: 'Penicilin', value: 'Penicilin' },
        { key: 'Mino', value: 'Mino' },
        { key: 'Cephalexin', value: 'Cephalexin' },
        { key: 'Tetra', value: 'Tetra' },
        { key: 'Azithromycin', value: 'Azithromycin' },
        { key: 'Clindamycin', value: 'Clindamycin' },
        { key: 'Amox', value: 'Amox' },
        { key: 'Erythromycin', value: 'Erythromycin' },
        { key: 'Amox/Clav', value: 'Amox/Clav' },
        { key: 'Isotretinoin', value: 'Isotretinoin' },
        { key: 'Other', value: 'Other' }
      ]
    }
  },
  {
    // 4-2
    label: 'Tell us more!',
    subLabel: 'Please write your answer in the space provided',
    field: 'finalOralMore',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Are you still using it?',
          type: 'single_select',
          level: 'child',
          halfWidth: true,
          options: [
            {
              key: 'oUsingYes',
              value: 'Yes'
            },
            {
              key: 'oUsingNo',
              value: 'No'
            }
          ]
        },
        {
          label: 'How did your skin respond, were there any side effects?',
          type: 'text',
          name: 'oSkinRespond'
        },
        {
          label: 'What strength of dosage did you use, and for how long?',
          type: 'text',
          name: 'oStrengthDosage'
        },
        {
          label:
            'Please provide any additional details you think may be useful.',
          type: 'text',
          name: 'oAdditional'
        }
      ]
    }
  },
  {
    // 5
    label: {
      text: '<h3>Quiz Complete</h3>',
      align: 'center',
      icon: 'check-circle'
    },
    field: 'finalComplete',
    type: 'info',
    answer: {
      label: 'Is there anything else you think we should know?',
      name: 'finalCompleteDesc',
      type: 'text',
      style: {
        round: true
      }
    }
  }
];

export default questionsModels;
